import { Link } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { DynamicTooltip } from 'shared/ui/Tooltip';

interface ColoredLinkBoxProps {
    color: string;
    tooltipText: string;
}

export const ColoredLinkBox = ({
    color,
    tooltipText,
    ...props
}: ColoredLinkBoxProps) => (
    <DynamicTooltip
        content={
            <Typography typography="openSans.caption">{tooltipText}</Typography>
        }
        enterDelay={200}
        offset={[0, 16]}
    >
        <Box
            sx={{
                width: '24px',
                height: '24px',
                borderRadius: '2px',
                padding: '4px',
                bgcolor: color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            {...props}
        >
            <Link sx={{ fontSize: '18px' }} />
        </Box>
    </DynamicTooltip>
);
